import BaseDto from '../BaseDto';

/**
 * Classe pour gérer le modèle lié au cours
 * Exchange avec le service Rest
 */
export default class CoursDto extends BaseDto {
  /**
   * Structure de la classe
   * @return {{dateNaissance: undefined, id: undefined, version: undefined, nom: undefined, prenom: undefined}}
   */
  get schema() { // eslint-disable-line
    return Object.assign(super.schema, {
      valeurMoyen: undefined,
      valeurCloture: undefined,
    });
  }

  /**
   * Construit la partie spécifique
   * @return {CoursDto}
   */
  buildCustom() {
    super.buildCustom();
    return this;
  }

  /**
   * Fonction appelée en callback pour créer une nouvelle instance
   * @param inoJson Flux json
   * @return {CoursDto}
   */
  static getFactory(inoJson = {}) {
    return new CoursDto(inoJson);
  }
}
